import React, {
  useMemo,
  useState,
  useEffect,
  useCallback,
  useImperativeHandle,
  forwardRef
} from 'react';

import { createPortal } from 'react-dom';

const modalRoot = document.querySelector('#modal-root');

function Modal(
  { children, position = 'center', size = 'medium', defaultOpened = false },
  ref
) {
  const [isOpen, openModal] = useState(defaultOpened);

  const open = useCallback(() => openModal(true), [openModal]);
  const close = useCallback(() => openModal(false), [openModal]);

  const handleEscape = useCallback(
    (e) => {
      if (e.keyCode === 27) close();
    },
    [close]
  );

  useEffect(() => {
    (function Mount() {
      if (isOpen) {
        document.addEventListener('keydown', handleEscape, false);
        document.body.classList.add('modal-open');
        modalRoot.setAttribute('style', 'display:block');
        modalRoot.classList.add('show');
      } else {
        modalRoot.removeAttribute('style');
        document.body.classList.remove('modal-open');
        modalRoot.classList.remove('show');
      }
    })();
    return () => {
      document.removeEventListener('keydown', handleEscape, false);
      document.body.classList.remove('modal-open');
    };
  }, [handleEscape, isOpen]);

  useImperativeHandle(
    ref,
    () => ({
      open,
      close
    }),
    [close, open]
  );

  const modal = useMemo(
    () => (
      <div className={`sdp-modal sdp-modal--${size} sdp-modal--${position}`}>
        <div className="sdp-modal-content">{children}</div>
      </div>
    ),
    [children, size, position]
  );

  return !isOpen ? null : createPortal(modal, modalRoot);
}

export default forwardRef(Modal);
